import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './styles/global.css';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0,
});

const initializeApp = () => {
  // URL 정리는 Supabase가 토큰을 처리한 후 AuthContext에서 담당
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
};

initializeApp();
